import React, {Fragment} from "react";


import './landing.css'

const Landing = () => {
    return (
      <Fragment>
        <div class="bg-image"  >
        <div class="container-fluid text-center">    
        
        
        <div class="text-justify  bg-light p-1 text-dark bg-opacity-50"> 
          <h1>Welcome To The Watering Can</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          <hr />
          <h3>What We Do</h3>
          <p>We will remind you when it's time to feed that foliage and quench your plants' thirst.</p>
        </div>
        
        </div>
      </div>
     
      </Fragment>
    )
}

export default Landing